export default defineI18nConfig(() => ({
    legacy: false,
    missingWarn: false,
    fallbackWarn: false,
    locale: 'en_INT',
    // messages,
    fallbackLocale: {
        de_CH: ['de', 'en_INT'],
        de_AT: ['de', 'en_INT'],
        de_DE: ['de', 'en_INT'],
        fr_CH: ['fr', 'en_INT'],
        fr_FR: ['fr', 'en_INT'],
        sv_SE: ['sv', 'en_INT'],
        da_DK: ['da', 'en_INT'],
        nl_NL: ['nl', 'en_INT'],
        en_GB: ['en', 'en_INT'],
        en_US: ['en', 'en_INT'],
        default: ['en', 'en_INT'],
    },
}));
